import { MenuItem, Select } from '@mui/material'
import React, { useEffect, useState } from 'react'

export interface MissingValueSelectProps {
  missingValue: MissingValueFilter | undefined
  handleChange: (missingValueFilter: MissingValueFilter | undefined) => void
  missingValueFilters: Record<string, MissingValueFilter>
}

export interface MissingValueFilter {
  label: string
  query: string
  value: string | number | boolean
}

export const MissingValueSelectComponent: React.FC<MissingValueSelectProps> = ({
  missingValueFilters,
  missingValue,
  handleChange
}) => {
  const [selectedMissingValue, setSelectedMissingValue] = useState<MissingValueFilter | undefined>(undefined)

  useEffect(() => {
    const value = missingValueFilters[missingValue?.label ?? '']
    setSelectedMissingValue(value ?? undefined)
  }, [missingValue])

  const handleMissingValueFilterSelection = (value: MissingValueFilter | undefined): void => {
    setSelectedMissingValue(value)
    handleChange(value)
  }

  return (
    <Select
      value={(selectedMissingValue != null) ? selectedMissingValue.label : ''}
      onChange={(e) => { handleMissingValueFilterSelection(missingValueFilters[e.target.value]) }}
      label="Missing Value"
    >
      <MenuItem value="">
        <em>None</em>
      </MenuItem>
      {Object.values(missingValueFilters).map((value, index) => (
        <MenuItem key={index} value={value.label}>
          {value.label}
        </MenuItem>
      ))}
    </Select>
  )
}
